import React from 'react';
import { addMonths, addYears, format } from 'date-fns';
import { useState } from 'react';
import { useOrdersChart } from './hooks/useDashboard';
import { Loading, useTranslate } from 'react-admin';
import { Typography, Box, TextField } from '@mui/material';
import { CustomAreaChart } from '../components/customCharts/CustomAreaChart';

function OrdersMovementChart() {
  const t = useTranslate();

  const [from, setFrom] = useState<Date>(addMonths(new Date(), -1));
  const [to, setTo] = useState<Date>(new Date());
  const { data, isLoading } = useOrdersChart(from.toString(), to.toString());
  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Typography variant='h5' textAlign={'center'}>
        {t('ordersMovement')}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
        }}
      >
        <TextField
          type={'date'}
          value={format(from, 'yyyy-MM-dd')}
          placeholder={t('from')}
          onChange={(e) => setFrom(new Date(e?.target?.value))}
          variant={'outlined'}
        />

        <TextField
          type={'date'}
          value={format(to, 'yyyy-MM-dd')}
          placeholder={t('to')}
          onChange={(e) => setTo(new Date(e?.target?.value))}
          variant={'outlined'}
        />
      </Box>

      <Box>
        <CustomAreaChart data={data} />
      </Box>
    </>
  );
}

export default OrdersMovementChart;
